import type HttpClient from "../../tastyworks/http"
import { updateSingleResponse } from "../../tastyworks/response"
import {
  SALESFORCE_IDENTITY_TOKEN_DESER,
  SalesforceIdentityToken,
} from "../../tastyworks/salesforce-identity-token"

export class SalesforceIdentityTokenService {
  constructor(private readonly baseHttpClient: HttpClient) {}

  readonly create = async () => {
    const helper = await this.baseHttpClient.postJson(
      "/oauth/salesforce-identity-token",
      {}
    )

    return updateSingleResponse(
      helper,
      new SalesforceIdentityToken(),
      SALESFORCE_IDENTITY_TOKEN_DESER.update
    )
  }
}
